@if (renderFrame) {
<his-page>
    <router-outlet />
</his-page>
} @else {
<router-outlet />
}
